import styled, { css } from 'styled-components';

import {
  ListboxInput,
  ListboxButton,
  ListboxPopover,
  ListboxList,
  ListboxOption,
} from '@reach/listbox';

import { IconWrapper, LabelWrapper } from '../button/index.styles';

import { popover } from '@demystdata/styles/z-index';

export const selectStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 100px;
  background: white;
  border: thin solid var(--coolGray-300);
  border-radius: 4px;
  font: inherit;
  line-height: 1;
  text-align: left;
  white-space: nowrap;
  user-select: none;
  transition: all 250ms ease;

  ${(props) =>
    (() => {
      switch (props.size) {
        case 'small':
          return css`
            min-height: 32px;
            padding: 0 8px;

            font-size: 14px;
          `;
        case 'regular':
        default:
          return css`
            min-height: 40px;
            padding: 0 8px;

            font-size: 16px;
          `;
      }
    })()}

  ${(props) =>
    props.disabled &&
    css`
      background-color: var(--coolGray-300);
      color: var(--coolGray-500);
    `}

  ${(props) =>
    !props.disabled &&
    css`
      outline: none;

      &:hover {
        border-color: var(--blue-400);
      }

      &:focus-within {
        border-color: var(--blue-700);
        box-shadow: 0 0 0 2px var(--indigoOutlineColor);
      }
    `}
`;

export const popoverStyles = css`
  max-height: 400px;
  padding: 8px;
  background-color: var(--white);
  border: 0;
  border-radius: 4px;
  box-shadow: var(--shadow-xl);
  overflow: auto;
  font: inherit;
  z-index: ${popover};
  outline: none;
`;

export const Button = styled(ListboxButton)`
  ${selectStyles}
`;

export const ButtonIconWrapper = styled(IconWrapper)`
  color: var(--coolGray-400);
`;

export const ButtonLabelWrapper = styled(LabelWrapper)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Popover = styled(ListboxPopover)`
  ${popoverStyles}

  &:focus-within {
    box-shadow: var(--shadow-xl);
  }
`;

export const List = styled(ListboxList)`
  margin: 0;
  padding: 0;
  list-style: none;
  outline: none;
`;

export const Option = styled(ListboxOption)`
  display: flex;
  gap: 8px;
  padding: 8px;
  white-space: nowrap;
  user-select: none;

  &[data-current-selected] {
    font-weight: 600;
  }

  &[data-current-nav] {
    background-color: var(--coolGray-100);
    color: inherit;
  }

  &[data-value='default'] {
    display: none;
  }
`;

export const OptionIconWrapper = styled.div`
  line-height: 0;
`;

export const OptionLabelWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Select = styled(ListboxInput)`
  &[data-value='default'] {
    ${Button} {
      color: var(--coolGray-300);
    }
  }
`;
